import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  steps: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
    lineHeight: theme.spacing(3),
  },
  disabledSteps: {
    opacity: 0.4,
    pointerEvents: 'none',
  },
  text: {
    fontSize: theme.spacing(2),
    fontWeight: 400,
  },
  stepBubble: {
    backgroundColor: theme.palette.bgSecondary.main,
    fontSize: theme.spacing(1.75),
    fontWeight: 500,
    height: theme.spacing(3.5),
    padding: theme.spacing(0, 1),
    width: 'fit-content',
    color: theme.palette.labraText.primary,
    borderRadius: theme.spacing(0.5),
    marginRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  linkText: {
    display: 'inline',
  },
  disabledLinkText: {
    opacity: 0.8,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  columns: {
    display: 'flex',
    flexDirection: 'column',
  },
  lineText: {
    marginBottom: theme.spacing(1),
  },
}))
